import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  Pagination,
  Paper,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomBreadcrumbs from "../../../../components/BreadcrumbsComponent/CustomBreadcrumbs";
import { Controller, FormProvider, useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SkeletonWrapper from "../../../../components/Skeleton/SkeletonWrapper";
import { CustomSelect } from "../../../../components/CustomFields/CustomSelect";
import { useLocation, useNavigate } from "react-router-dom";
import { EncryptDecryptService } from "../../../../services/common/EncryptionService";
import { PreferencesContext } from "../../../../PreferenceContext";
import { PAGE_SIZE } from "../../../../services/common/const";
import { AlertType } from "../../../../services/models/AlertType";
import { LoadingButton } from "@mui/lab";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  CreateReportParameter,
  DeleteInvestigationReportParameter,
  GetInvestigationParameterList,
  GetReportParameterDetailById,
  UpdateReportParameter,
} from "../../../../services/ReportParameterService";
import { GetInvestigationList } from "../../../../services/InvestigationService";
import * as Yup from "yup";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Edit } from "@mui/icons-material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ReportParameterForRange from "./ReportParameterForRange";

// SCHEMA FOR PARAMETER
interface Parameter {
  investigationParameterId: string;
  pageIndex: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;
  searchValue: string;
  tabType: number;
}
// DEFAULT PARAMS -- ADD HERE IF YOU NEED NEW PARAMETER
const parameters: Parameter = {
  investigationParameterId: "",
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
  tabType: 0,
};

interface ReportParameterDetail {
  reportParameterDetailId: number;
  investigationparameterid: number;
  parameterName: string | null;
  specimen: string | null;
  unitName: string | null;
  remarks: string | null;
  isChecked: boolean;
  isDeleted: boolean;
}

interface ReportParameter {
  reportParameterId: number;
  parameterName: string | null;
  investigationId: number;
  investigationName: string | null;
  reportParameterDetailColl: Array<ReportParameterDetail>;
  displayOrder: number;
  isDeleted: boolean;
}

const ReportParameterSave = (props: any) => {
  // PROPS
  const { isForPopUp = false, handleClosePopUp } = props;

  // DEFAULT SCHEMA VALUE FOR FORM
  const initReportParameterData: ReportParameter = {
    reportParameterId: 0,
    parameterName: "",
    investigationId: 0,
    investigationName: "",
    reportParameterDetailColl: [],
    displayOrder: 0,
    isDeleted: false,
  };

  // HOOKS AND CONTEXT
  const navigate = useNavigate();
  const edService = new EncryptDecryptService();
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [investigationData, setInvestigationData] = useState<any[]>([]);
  const [param, setParam] = useState(parameters);
  const [reportParameterData, setReportParameterData] = useState<any[]>([]);
  const [selected, setSelected] = useState<readonly number[]>([]);
  const [openParameterDialog, setOpenParameterDialog] =
    useState<boolean>(false);
  const [dialogSelected, setDialogSelected] = useState<readonly number[]>([]);
  const [counData, setCounData] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageStartIndex, setPageStartIndex] = useState(1);
  const [pageEndIndex, setPageEndIndex] = useState(1);
  const [dialogPage, setDialogPage] = useState(1);
  const [parameterData, setParameterData] = useState<Record<number, any>>({});
  const [checked, setChecked] = useState<number[]>([]);
  const [openDeleteDilog, setOpenDeleteDilog] = React.useState(false);
  const [reportParameterDetailId, setReportParameterDetailId] =
    React.useState(false);
  const [openRangeDialog, setOpenRangeDialog] = useState<boolean>(false);
  const [selectedRangeRow, setSelectedRangeRow] = useState<any>(null);
  const [openQuickRangeDialog, setOpenQuickRangeDialog] = useState<boolean>(false);
  const [quickRangeRow, setQuickRangeRow] = useState<any>(null);
  const [quickRangeSelected, setQuickRangeSelected] = useState<Record<number, string>>({});

  function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }

  // GETTTING PARAMS
  let urlParams = useQuery();
  let curRawReportParameterId = urlParams.get("q");
  let curReportParameterId = 0;
  let page = urlParams.get("page");
  const qParam = urlParams.get("rq");
  let encodedQuery = qParam;
  let query = qParam || "";
  let curPage = 1;

  if (
    page != null &&
    page != "" &&
    page != undefined &&
    encodedQuery != null &&
    encodedQuery != undefined
  ) {
    curPage = +page;
    // Encoded Query
    encodedQuery = encodeURIComponent(encodedQuery);
    // Decode Query
    query = decodeURIComponent(encodedQuery);
  } else {
  }

  if (
    curRawReportParameterId !== null &&
    curRawReportParameterId !== undefined &&
    !isForPopUp
  ) {
    let decId = edService.decrypt(curRawReportParameterId);
    if (decId !== "" && decId !== null && decId !== undefined) {
      curReportParameterId = +decId;
    }
  }

  const [value, setValue] = useState(query || "");
  const [dialogSearch, setDialogSearch] = useState("");

  const getOptionValues = (optionValue: any) => {
    if (!optionValue) return [];
    if (Array.isArray(optionValue)) return optionValue;
    if (typeof optionValue !== "string") return [];
    try {
      const cleanJson = optionValue.replace(/,\s*}/g, "}").replace(/,\s*]/g, "]");
      const parsed = JSON.parse(cleanJson);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const handleManagePopup = async (code: string) => {
    setOpenRangeDialog(false);
    setSelectedRangeRow(null);
    if (code === "REPORT_PARAMETER") {
      await fetchInvestigationReportParameterList([], dialogPage, dialogSearch);
    }
  };

  const handleOpenAddPopup = async () => {
    setDialogPage(1);
    setDialogSelected(selected);
    setValue("");
    setDialogSearch("");

    const existingRangeSelections: Record<number, string> = {};
    Object.values(parameterData).forEach((item: any) => {
      if (item?.investigationParameterId && item?.rangeValue) {
        existingRangeSelections[item.investigationParameterId] = item.rangeValue;
      }
    });
    setQuickRangeSelected((prev) => ({ ...existingRangeSelections, ...prev }));

    setOpenParameterDialog(true);
    await fetchInvestigationReportParameterList([], 1, "");
  };

  const handleCheckSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const currentPageIds = reportParameterData?.map(
        (row: any) => row?.investigationParameterId || 0,
      );
      const merged = Array.from(
        new Set([...(dialogSelected || []), ...currentPageIds]),
      );
      setDialogSelected(merged);
      return;
    }
    const currentPageIds = new Set(
      reportParameterData?.map((row: any) => row?.investigationParameterId),
    );
    setDialogSelected(
      (dialogSelected || []).filter((id) => !currentPageIds.has(id)),
    );
  };

  // ON SEARCH
  const searchValue = async (val: string) => {
    const searchText = val.trim();
    setValue(searchText);
    setDialogSearch(searchText);
    setDialogPage(1);
    await fetchInvestigationReportParameterList([], 1, searchText);
  };

  //SCHEMA VALIDATION
  const validationSchema = Yup.object().shape({
    investigationId: Yup.mixed().nullable(),
    investigationName: Yup.string().required("Investigation is required."),
    reportParameterDetailColl: Yup.array().of(
      Yup.object().shape({
        reportParameterDetailId: Yup.number().nullable(),
        investigationParameterId: Yup.number().nullable(),
        parameterName: Yup.string().nullable(),
        specimen: Yup.string().nullable(),
        unitName: Yup.string().nullable(),
        remarks: Yup.string().nullable(),
        isChecked: Yup.boolean().nullable(),
        displayOrder: Yup.number().nullable(),
      }),
    ),
  });

  // FORM HOOK
  const methods = useForm({
    resolver: yupResolver(validationSchema), // IGNORE THIS ERROR
    defaultValues: initReportParameterData, // DEFAULT VALUE -- DON'T CREATE STATE FOR IT -- STATE CAN INCREASE SITE LOAD
  });

  const isInvestigationSelected = useWatch({
    control: methods?.control,
    name: "investigationId",
  });

  // ON CHANGE PAGE
  const handleDialogPageChange = async (
    event: React.ChangeEvent<unknown>,
    pageNumber: number,
  ) => {
    setDialogPage(pageNumber);
    await fetchInvestigationReportParameterList([], pageNumber, dialogSearch);
  };

  // HANDLE DELETE WARNING POPUP
  const handleDeleteDilog = (value: any) => {
    setOpenDeleteDilog(value);
  };

  // GET INVESTIGATION LIST
  const fetchInvestigationList = async (
    searchValue: string,
    onInit: boolean,
  ) => {
    try {
      let investigationColl = [];
      let params = new URLSearchParams();
      params.append("ConsumerId", userContext?.consumerId.toString());
      params.append("OrgId", userContext?.organizationId.toString());
      params.append("BranchId", userContext?.branchId.toString());
      params.append("pageIndex", param.pageIndex?.toString());
      params.append("pageSize", param.pageSize?.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", searchValue);
      params.append("isFor", "OPD");
      params.append("mode", "DROPDOWN");
      params.append("symptomIds", "");
      params.append("investigationTypeCode", "OTHER");
      const result: any = await GetInvestigationList(params);
      if (result?.data?.data?.investigationColl) {
        investigationColl = result?.data?.data.investigationColl;
        if (onInit) setInvestigationData(investigationColl);
      }
      return investigationColl;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  // GET INVESTIGATION PARAMETER LIST
  async function fetchInvestigationReportParameterList(
    existingColl: any[] = [],
    pageIndex: number = dialogPage,
    searchText: string = "",
  ) {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId?.toString());
      params.append("orgId", userContext.organizationId?.toString());
      params.append("branchId", userContext.branchId?.toString());
      params.append("pageIndex", pageIndex?.toString());
      params.append("pageSize", param.pageSize?.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", searchText);
      params.append("mode", "LIST".toString());
      const result: any = await GetInvestigationParameterList(params);
      const rawColl = result?.data?.data?.investigationParameterColl ?? [];
      const resultData = result?.data?.data;
      const dataCount = resultData?.totalCount || 0;
      setTotalCount(dataCount);
      const showDataCount = Math.ceil(dataCount / param.pageSize);
      setCounData(showDataCount);
      const startIndex =
        dataCount > 0 ? (pageIndex - 1) * param.pageSize + 1 : 0;
      const endIndex = (pageIndex - 1) * param.pageSize + rawColl?.length || 0;
      setPageStartIndex(startIndex);
      setPageEndIndex(endIndex);

      const passedExisting = new Map(
        (existingColl || []).map((d: any) => [d.investigationParameterId, d]),
      );
      const finalColl = rawColl.map((item: any) => {
        const known =
          parameterData[item.investigationParameterId] ||
          passedExisting.get(item.investigationParameterId);
        return {
          ...item,
          reportParameterDetailId: known?.reportParameterDetailId || 0,
        };
      });
      setReportParameterData(finalColl);
      setParameterData((prev) => {
        const updated = { ...prev };
        finalColl?.forEach((item: any) => {
          updated[item.investigationParameterId] = item;
        });
        return updated;
      });
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  const saveReportParameter = async (value: ReportParameter) => {
    try {
      let result: any = "";

      const selectedRows = Array.from(new Set([...selected, ...checked]));

      const saveDetailColl = selectedRows
        ?.map((id) => parameterData[id])
        ?.filter(Boolean)
        ?.map((reportParameter: any, index: number) => {
          const isRowChecked = selected.includes(
            reportParameter.investigationParameterId,
          );
          const existingDetailId =
            reportParameter?.reportParameterDetailId || 0;
          return {
            reportParameterDetailId: existingDetailId,
            investigationParameterId: reportParameter.investigationParameterId,
            displayOrder: index + 1,
            investigationId: reportParameter.investigationId,
            investigationName: reportParameter.investigationName,
            parameterName: reportParameter.parameterName,
            specimen: reportParameter.specimen,
            unitName: reportParameter.unitName,
            remarks: reportParameter.remarks,
            isChecked: isRowChecked,
            isDeleted: !isRowChecked,
            mode: existingDetailId > 0 ? "U" : "I",
          };
        });

      const parameterName =
        selected
          .map((id) => parameterData[id])
          .filter(Boolean)
          .map((item: any) => item.parameterName)
          ?.join(", ") || "";

      let formData = {
        reportParameterId: value?.reportParameterId,
        consumerId: userContext?.consumerId?.toString(),
        orgId: userContext?.organizationId?.toString(),
        branchId: userContext?.branchId?.toString(),
        parameterName: parameterName,
        investigationId: value?.investigationId?.value,
        investigationName: value?.investigationName,
        reportParameterDetailCollJson: JSON.stringify(saveDetailColl),
        dataManagedBy: userContext.loginDetail.userId,
      };
      if (curReportParameterId > 0) {
        result = await UpdateReportParameter(formData);
      } else {
        result = await CreateReportParameter(formData);
      }
      if (result) {
        navigate(-1);
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result?.message,
          alertType: AlertType.Success,
        });
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Something went wrong.",
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  // GET DETAIL
  const getResultParameterDetailById = async () => {
    let resultParameter: any;
    let params = new URLSearchParams();
    params.append("reportParameterId", curReportParameterId.toString());
    params.append("consumerId", userContext.consumerId.toString());
    params.append("organizationId", userContext.organizationId.toString());
    params.append("branchId", userContext.branchId.toString());

    try {
      const res: any = await GetReportParameterDetailById(params);
      resultParameter = res.data.data;
      methods.reset({
        ...initReportParameterData,
        reportParameterId: resultParameter?.reportParameterId || 0,
        reportParameterDetailId: resultParameter?.reportParameterDetailId || 0,
        investigationparameterid:
          resultParameter?.investigationparameterid || 0,
        investigationId: resultParameter?.investigationId
          ? {
            value: resultParameter?.investigationId?.toString(),
            label: resultParameter?.investigationName || "",
          }
          : null,
        investigationName: resultParameter?.investigationName || "",
        parameterName: resultParameter?.parameterName || "",
        specimen: resultParameter?.specimen || "",
        unitName: resultParameter?.unitName || "",
        remarks: resultParameter?.remarks || "",
        reportParameterDetailColl:
          resultParameter?.reportParameterDetailColl || [],
      });
      const checkedIds = (resultParameter?.reportParameterDetailColl || [])
        .filter((x: any) => x.isChecked)
        .map((x: any) => x.investigationParameterId);
      setSelected(checkedIds);
      setChecked(checkedIds);
      setParameterData((prev) => {
        const updated = { ...prev };
        (resultParameter?.reportParameterDetailColl || []).forEach(
          (item: any) => {
            updated[item.investigationParameterId] = item;
          },
        );
        return updated;
      });
      return resultParameter;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  // HANDLE DELETE
  async function deleteRow(reportParameterDetailIds: any) {
    try {
      handleDeleteDilog(false);
      let DeleteData = {
        reportParameterDetailIds: reportParameterDetailIds?.toString(),
        consumerId: userContext?.consumerId?.toString(),
        organizationId: userContext?.organizationId?.toString(),
        branchId: userContext?.branchId?.toString(),
        isDeleted: true,
        isChecked: false,
        dataManagedBy: userContext?.loginDetail?.userId,
      };
      const result: any = await DeleteInvestigationReportParameter(DeleteData);
      if (result) {
        await getResultParameterDetailById();
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Success,
        });
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  const onSubmit = (data: any) => {
    saveReportParameter(data);
  };

  // HANDLE BACK
  const handleBack = () => {
    if (!isForPopUp) {
      navigate(-1);
    } else {
      handleClosePopUp("CLOSE");
    }
  };

  // FETCH DATA
  const fetchData = async () => {
    try {
      await fetchInvestigationList("", true);
      let resultParameter: any = null;
      if (curReportParameterId > 0) {
        resultParameter = await getResultParameterDetailById();
      }
      await fetchInvestigationReportParameterList(
        resultParameter?.reportParameterDetailColl || [],
        dialogPage,
      );
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  // USE EFFECTS
  useEffect(() => {
    setIsLoading(true);
    fetchData();
  }, [curReportParameterId, param, curPage, query]);

  return (
    <>
      <Box className="main-container">
        <Grid xs={12} container className="page-header">
          <Grid item xs={6} sm={6} md={6}>
            <Box
              sx={{
                display: "flex",
                height: "100%",
                alignItems: "center",
              }}
            >
              <CustomBreadcrumbs />
            </Box>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <Box className="page-header-icon">
              <Button
                color="primary"
                variant="outlined"
                type="button"
                className="secondary-button"
                onClick={handleBack}
                startIcon={<ArrowBackIcon />}
              >
                Back
              </Button>
            </Box>
          </Grid>
        </Grid>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)} action="">
            <Grid container gap={2}>
              <Grid item xs={12} className={"group-container"}>
                <Grid
                  container
                  item
                  spacing={2}
                  alignItems="flex-end"
                  justifyContent="space-between"
                >
                  <Grid item xs={12} sm={6} lg={4}>
                    <FormControl fullWidth>
                      <FormLabel
                        className={`fileds-label-text  ${
                          methods.formState.errors.investigationName
                          ? "validation-message"
                          : ""
                          }`}
                      >
                        Investigation *
                      </FormLabel>
                      <SkeletonWrapper
                        isLoading={isLoading}
                        className="skeleton-input"
                      >
                        <Controller
                          control={methods.control}
                          name={`investigationId`}
                          render={({ field }) => (
                            <CustomSelect
                              {...field}
                              value={field.value}
                              isNotCreatable={true}
                              id="investigationName"
                              FieldName="investigationName"
                              options={investigationData}
                              openMenuOnFocus
                              isClearable
                              isSearchable
                              isDisabled={curReportParameterId > 0}
                              menuPortalTarget={document.querySelector("body")}
                              onInputChange={(inputValue: any, actionMeta: any) => {
                                if (actionMeta.action === "input-change") {
                                  fetchInvestigationList(inputValue, true);
                                }
                              }}
                              handleChange={async (e: any) => {
                                field.onChange(e ?? null);
                                methods.setValue(
                                  "investigationName",
                                  e?.label ?? "",
                                  {
                                    shouldValidate: true,
                                  },
                                );
                                setSelected([]);
                                setDialogSelected([]);
                                setParameterData({});
                                setChecked([]);
                                await fetchInvestigationReportParameterList();
                              }}
                            />
                          )}
                        />
                      </SkeletonWrapper>
                      <Typography className="validation-message">
                        {methods.formState.errors.investigationName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    lg={8}
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xs: "flex-start",
                        lg: "flex-end",
                      },
                      alignItems: "flex-end",
                    }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleOpenAddPopup}
                      size="medium"
                      disabled={!isInvestigationSelected}
                    >
                      Add Parameter
                    </Button>
                  </Grid>

                  <Grid item xs={12} mt={2}>
                    <TableContainer>
                      <Table>
                        <TableHead className="table-header-color">
                          <TableRow>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                width: "35%",
                              }}
                              align="left"
                            >
                              Parameter
                            </TableCell>
                            <TableCell
                              sx={{
                                display: {
                                  xs: "none",
                                  sm: "table-cell",
                                },
                                fontWeight: "bold",
                                width: "35%",
                              }}
                              align="left"
                            >
                              Specimen
                            </TableCell>
                            <TableCell
                              sx={{
                                display: {
                                  xs: "none",
                                  sm: "table-cell",
                                },
                                fontWeight: "bold",
                                width: "30%",
                              }}
                              align="left"
                            >
                              Unit
                            </TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selected
                            ?.map((id) => parameterData[id])
                            ?.filter(Boolean)?.length > 0 ? (
                            selected
                              .map((id) => parameterData[id])
                              .filter(Boolean)
                              .map((row: any) => (
                                <TableRow key={row?.investigationParameterId}>
                                  <TableCell
                                    sx={{
                                      display: {
                                        sm: "table-cell",
                                      },
                                    }}
                                  >
                                    {row.parameterName}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      display: {
                                        xs: "none",
                                        sm: "table-cell",
                                      },
                                    }}
                                  >
                                    {row.specimen}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      display: {
                                        xs: "none",
                                        sm: "table-cell",
                                      },
                                    }}
                                  >
                                    {row.unitName}
                                  </TableCell>
                                  <TableCell align="right">
                                    <Tooltip title="More" placement="top">
                                      <IconButton
                                        onClick={(e: any) => {
                                          setReportParameterDetailId(
                                            row?.reportParameterDetailId || 0
                                          );
                                          handleDeleteDilog(true);
                                        }}
                                      >
                                        <CloseRoundedIcon
                                          sx={{
                                            fontSize: "18px !important",
                                            color: "#d32f2f",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={5} align="center">
                                No record(s) found
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ display: "flex", justifyContent: "end", gap: 2 }}>
                  <LoadingButton
                    color="primary"
                    loadingPosition="start"
                    startIcon={<></>}
                    variant="contained"
                    type="submit"
                    className="primary-button"
                    name="save"
                    disabled={isLoading || methods.formState.isSubmitting}
                  >
                    {curReportParameterId > 0 ? "Update" : "Save"}
                  </LoadingButton>
                  <LoadingButton
                    color="primary"
                    loadingPosition="start"
                    startIcon={<></>}
                    variant="outlined"
                    type="button"
                    className="secondary-button"
                    name="cancel"
                    disabled={isLoading || methods.formState.isSubmitting}
                    onClick={handleBack}
                  >
                    Cancel
                  </LoadingButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </Box>

      <Dialog
        open={openParameterDialog}
        onClose={() => setOpenParameterDialog(false)}
        fullScreen
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBar
          sx={{
            position: "relative",
            backgroundColor: "#f8fafc",
          }}
        >
          <Toolbar>
            <Typography
              style={{ fontWeight: 600, marginLeft: 0 }}
              sx={{ ml: 2, flex: 1 }}
              variant="h6"
            >
              Add Parameter
            </Typography>
          </Toolbar>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </AppBar>
        <Grid item xs={8} sm={8} md={8} lg={10} sx={{ gap: 2 }}>
          <SkeletonWrapper
            isLoading={isLoading}
            className="skeleton-search-box"
          >
            <TextField
              id="searchBox"
              placeholder="Search..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  searchValue(value);
                }
              }}
              type="text"
              variant="outlined"
              size="small"
              onChange={(e) => setValue(e.target.value)}
              value={value}
              sx={{
                padding: "20px 20px 0px 20px",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      size="small"
                      onClick={() => {
                        searchValue(value);
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: value && (
                  <IconButton
                    aria-label="clear search"
                    onClick={() => {
                      searchValue("");
                      setValue("");
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
            />
          </SkeletonWrapper>
        </Grid>
        <DialogContent
          sx={{
            pb: 0,
            pl: 0,
            pr: 0,
          }}
        >
          {reportParameterData?.length > 0 ? (
            <>
              {/* DESKTOP / TABLET VIEW */}
              <TableContainer
                component={Paper}
                elevation={0}
                sx={{
                  display: { xs: "none", sm: "block" },
                  height: "100%",
                  maxHeight: "none",
                  overflowY: "auto",
                }}
              >
                <Table size="small">
                  <TableHead
                    sx={{
                      "& .MuiTableCell-head": {
                        padding: "8px !important",
                      },
                    }}
                  >
                    <TableRow>
                      <TableCell sx={{ width: "5%" }}>
                        <Checkbox
                          checked={
                            reportParameterData?.length > 0 &&
                            reportParameterData.every((row: any) =>
                              dialogSelected?.includes(
                                row.investigationParameterId,
                              ),
                            )
                          }
                          indeterminate={
                            reportParameterData?.some((row: any) =>
                              dialogSelected?.includes(
                                row.investigationParameterId,
                              ),
                            ) &&
                            !reportParameterData?.every((row: any) =>
                              dialogSelected?.includes(
                                row.investigationParameterId,
                              ),
                            )
                          }
                          onChange={handleCheckSelectAll}
                        />
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", width: "15%" }}
                        align="left"
                      >
                        Parameter
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", width: "10%" }}
                        align="left"
                      >
                        Specimen
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", width: "10%" }}
                        align="left"
                      >
                        Unit
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", width: "10%" }}
                        align="left"
                      >
                        Parameter Type
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", width: "30%" }}
                        align="left"
                      >
                        Value
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", width: "20%" }}
                        align="left"
                      >
                        Range
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reportParameterData.map((row: any) => (
                      <TableRow key={row.investigationParameterId}>
                        <TableCell sx={{ width: "5%" }}>
                          <Checkbox
                            checked={dialogSelected?.includes(
                              row.investigationParameterId,
                            )}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setDialogSelected([
                                  ...dialogSelected,
                                  row.investigationParameterId,
                                ]);
                              } else {
                                setDialogSelected(
                                  dialogSelected.filter(
                                    (id) => id !== row.investigationParameterId,
                                  ),
                                );
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell>{row.parameterName}</TableCell>
                        <TableCell>{row.specimen}</TableCell>
                        <TableCell>{row.unitName}</TableCell>
                        <TableCell>{row.parameterType}</TableCell>

                        {/* VALUE */}
                        <TableCell>
                          {row?.parameterType === "Qualitative" && (
                            <Box
                              sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                            >
                              {getOptionValues(row?.optionValue)?.map(
                                (item: any, index: number) => (
                                  <Box
                                    key={
                                      item?.memberPatientReportParameterForRangeValueId ??
                                      `${row.investigationParameterId}-${index}`
                                    }
                                    className="quick-chip"
                                    sx={{
                                      padding: "6px 10px !important",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      lineHeight: 1,
                                    }}
                                    onClick={() => {
                                      setSelectedRangeRow({
                                        ...row,
                                        optionValue: item?.optionValue || "",
                                        memberPatientReportParameterForRangeValueId:
                                          item?.memberPatientReportParameterForRangeValueId ||
                                          0,
                                      });
                                      setOpenRangeDialog(true);
                                    }}
                                  >
                                    <span>{item?.optionValue}</span>
                                    <Tooltip
                                      title="Edit Option Value"
                                      placement="top"
                                    >
                                      <Button
                                        sx={{
                                          minWidth: "20px",
                                          width: "20px",
                                          height: "20px",
                                          padding: 0,
                                          marginTop: "-3px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        <Edit
                                          fontSize="inherit"
                                          sx={{
                                            width: "14px !important",
                                            height: "14px !important",
                                          }}
                                        />
                                      </Button>
                                    </Tooltip>
                                  </Box>
                                ),
                              )}
                              <Tooltip title="Add Option Value" placement="top">
                                <IconButton size="small">
                                  <AddOutlinedIcon
                                    fontSize="small"
                                    className="text-link link-cursor"
                                    onClick={() => {
                                      setSelectedRangeRow({
                                        ...row,
                                        optionValue: "",
                                        memberPatientReportParameterForRangeValueId: 0,
                                      });
                                      setOpenRangeDialog(true);
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          )}
                        </TableCell>

                        {/* RANGE */}
                        <TableCell>
                          {row?.parameterType === "Qualitative" ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                flexWrap: "wrap",
                              }}
                            >
                              {quickRangeSelected[row.investigationParameterId] ? (
                                <Box
                                  className="quick-chip"
                                  sx={{
                                    padding: "6px 10px !important",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    lineHeight: 1,
                                  }}
                                >
                                  <span>
                                    {quickRangeSelected[row.investigationParameterId]}
                                  </span>
                                  <Tooltip title="Edit Range" placement="top">
                                    <Button
                                      sx={{
                                        minWidth: "20px",
                                        width: "20px",
                                        height: "20px",
                                        padding: 0,
                                        marginTop: "-3px",
                                        marginLeft: "2px",
                                      }}
                                      onClick={() => {
                                        setQuickRangeRow(row);
                                        setOpenQuickRangeDialog(true);
                                      }}
                                    >
                                      <Edit
                                        fontSize="inherit"
                                        sx={{
                                          width: "14px !important",
                                          height: "14px !important",
                                        }}
                                      />
                                    </Button>
                                  </Tooltip>
                                </Box>
                              ) : (
                                <IconButton size="small">
                                  <AddOutlinedIcon
                                    fontSize="small"
                                    className="text-link link-cursor"
                                    onClick={() => {
                                      setQuickRangeRow(row);
                                      setOpenQuickRangeDialog(true);
                                    }}
                                  />
                                </IconButton>
                              )}
                            </Box>
                          ) : (
                            row.rangeValue
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* MOBILE VIEW */}
              <Box sx={{ display: { xs: "block", sm: "none" }, px: 2 }}>
                {reportParameterData.map((row: any, idx: number) => (
                  <Box
                    key={row.investigationParameterId}
                    sx={{
                      borderBottom:
                        idx === reportParameterData.length - 1
                          ? "none"
                          : "1px solid #e2e8f0",
                      py: 0.5,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography>
                        <span style={{ fontWeight: "bold" }}>Parameter:</span>{" "}
                        {row.parameterName || ""}
                      </Typography>
                      <Checkbox
                        checked={dialogSelected?.includes(
                          row.investigationParameterId,
                        )}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setDialogSelected([
                              ...dialogSelected,
                              row.investigationParameterId,
                            ]);
                          } else {
                            setDialogSelected(
                              dialogSelected.filter(
                                (id) => id !== row.investigationParameterId,
                              ),
                            );
                          }
                        }}
                      />
                    </Box>
                    <Typography>
                      <span style={{ fontWeight: "bold" }}>Specimen:</span>{" "}
                      {row.specimen || "-"}
                    </Typography>
                    <Typography>
                      <span style={{ fontWeight: "bold" }}>Unit:</span>{" "}
                      {row.unitName || "-"}
                    </Typography>
                    <Typography>
                      <span style={{ fontWeight: "bold" }}>Parameter Type:</span>{" "}
                      {row.parameterType || "-"}
                    </Typography>

                    {/* VALUE */}
                    <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                      <span style={{ fontWeight: "bold" }}>Value:</span>
                      {row?.parameterType === "Qualitative" && (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {getOptionValues(row?.optionValue)?.map(
                            (item: any, index: number) => (
                              <Box
                                key={
                                  item?.memberPatientReportParameterForRangeValueId ??
                                  `${row.investigationParameterId}-${index}`
                                }
                                sx={{
                                  border: "1px solid rgb(198 220 235)",
                                  borderRadius: "8px",
                                  padding: "3px 5px !important",
                                  height: "22px !important",
                                  minHeight: "22px",
                                  color: "#222",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "2px",
                                }}
                                onClick={() => {
                                  setSelectedRangeRow({
                                    ...row,
                                    optionValue: item?.optionValue || "",
                                    memberPatientReportParameterForRangeValueId:
                                      item?.memberPatientReportParameterForRangeValueId ||
                                      0,
                                  });
                                  setOpenRangeDialog(true);
                                }}
                              >
                                <span>{item?.optionValue}</span>
                                <Tooltip title="Edit Option Value" placement="top">
                                  <Button
                                    sx={{
                                      minWidth: "20px",
                                      width: "20px",
                                      height: "20px",
                                      padding: 0,
                                      marginTop: "-3px",
                                      marginLeft: "2px",
                                    }}
                                  >
                                    <Edit
                                      fontSize="inherit"
                                      sx={{
                                        width: "14px !important",
                                        height: "14px !important",
                                      }}
                                    />
                                  </Button>
                                </Tooltip>
                              </Box>
                            ),
                          )}
                          <Tooltip title="Add Option Value" placement="top">
                            <IconButton size="small" sx={{ padding: 0 }}
                              onClick={() => {
                                setSelectedRangeRow({
                                  ...row,
                                  optionValue: "",
                                  memberPatientReportParameterForRangeValueId: 0,
                                });
                                setOpenRangeDialog(true);
                              }}
                            >
                              <AddOutlinedIcon
                                sx={{
                                  fontSize: "18px !important",
                                  color: "primary.main",
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}
                    </Box>

                    {/* RANGE */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                        mt: 0.5,
                        mb: 1,
                      }}
                    >
                      <span style={{ fontWeight: "bold" }}>Range:</span>
                      {row?.parameterType === "Qualitative" ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            flexWrap: "wrap",
                          }}
                        >
                          {quickRangeSelected[row.investigationParameterId] ? (
                            <Box
                              sx={{
                                border: "1px solid rgb(198 220 235)",
                                borderRadius: "8px",
                                padding: "3px 5px !important",
                                height: "22px !important",
                                minHeight: "22px",
                                color: "#222",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <span>
                                {quickRangeSelected[row.investigationParameterId]}
                              </span>
                              <Tooltip title="Edit Range" placement="top">
                                <Button
                                  sx={{
                                    minWidth: "20px",
                                    width: "20px",
                                    height: "20px",
                                    padding: 0,
                                    marginTop: "-3px",
                                    marginLeft: "2px",
                                  }}
                                  onClick={() => {
                                    setQuickRangeRow(row);
                                    setOpenQuickRangeDialog(true);
                                  }}
                                >
                                  <Edit
                                    fontSize="inherit"
                                    sx={{
                                      width: "14px !important",
                                      height: "14px !important",
                                    }}
                                  />
                                </Button>
                              </Tooltip>
                            </Box>
                          ) : (
                            <IconButton
                              size="small"
                              sx={{ padding: 0 }}
                              onClick={() => {
                                setQuickRangeRow(row);
                                setOpenQuickRangeDialog(true);
                              }}
                            >
                              <AddOutlinedIcon
                                sx={{
                                  fontSize: "18px !important",
                                  color: "primary.main",
                                  cursor: "pointer",
                                }}
                              />
                            </IconButton>
                          )}
                        </Box>
                      ) : (
                        row.rangeValue
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            </>
          ) : (
            <Box sx={{ p: 4, textAlign: "center" }}>
              <Typography color="text.secondary">No record(s) found</Typography>
            </Box>
          )}
        </DialogContent>
        {/* PAGINATION */}
        {totalCount > 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2,
              py: 1,
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Typography variant="body2">
              {pageStartIndex} - {pageEndIndex} of {totalCount}
            </Typography>
            <Stack>
              <Pagination
                color="primary"
                count={counData}
                page={dialogPage}
                onChange={handleDialogPageChange}
              />
            </Stack>
          </Box>
        )}
        <DialogActions>
          <Button
            color="primary"
            variant="outlined"
            className="secondary-button"
            onClick={() => setOpenParameterDialog(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            className="primary-button"
            onClick={() => {
              setSelected(dialogSelected);
              setOpenParameterDialog(false);
            }}
          >
            Add Selected
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDeleteDilog}
        onClose={() => {
          handleDeleteDilog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this parameter?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              deleteRow(reportParameterDetailId);
            }}
            className="button-delete"
          >
            Yes
          </Button>
          <Button
            onClick={(e) => {
              handleDeleteDilog(false);
            }}
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* VALUE OPTION DIALOG */}
      <Dialog
        className="dialogPage"
        open={openRangeDialog}
        onClose={() => setOpenRangeDialog(false)}
        fullScreen
        PaperProps={{
          style: { width: "500px", height: "250px", maxWidth: "none", borderRadius: "10px" },
        }}
      >
        <AppBar sx={{ position: "relative", backgroundColor: "#f8fafc" }}>
          <Toolbar>
            <Typography
              style={{ fontWeight: 600, marginLeft: 0 }}
              sx={{ ml: 2, flex: 1 }}
              variant="h6"
            >
              Value Option
            </Typography>
          </Toolbar>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </AppBar>
        <DialogContent sx={{ padding: "12px 24px" }}>
          <ReportParameterForRange
            handleClosePopUp={(code: any) => handleManagePopup(code)}
            isForPopUp={true}
            name=""
            opd={{ opdId: 0, patientId: 0 }}
            code="RANGE_VALUE"
            investigationId={methods.getValues("investigationId")?.value}
            investigationParameterId={selectedRangeRow?.investigationParameterId}
            optionValue={selectedRangeRow?.optionValue || ""}
            memberPatientReportParameterForRangeValueId={
              selectedRangeRow?.memberPatientReportParameterForRangeValueId || 0
            }
          />
        </DialogContent>
      </Dialog>

      {/* QUICK RANGE DIALOG */}
      <Dialog
        className="dialogPage"
        open={openQuickRangeDialog}
        onClose={() => setOpenQuickRangeDialog(false)}
        fullScreen
        PaperProps={{
          style: { width: "500px", height: "250px", maxWidth: "none", borderRadius: "10px" },
        }}
      >
        <AppBar sx={{ position: "relative", backgroundColor: "#f8fafc" }}>
          <Toolbar>
            <Typography
              style={{ fontWeight: 600, marginLeft: 0 }}
              sx={{ ml: 2, flex: 1 }}
              variant="h6"
            >
              Range
            </Typography>
            <IconButton
              onClick={() => setOpenQuickRangeDialog(false)}
              aria-label="close"
              sx={{ color: "#555" }}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </AppBar>
        <DialogContent sx={{ padding: "12px 24px" }}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {getOptionValues(quickRangeRow?.optionValue)?.map((item: any, index: number) => {
              const isSelected =
                quickRangeRow &&
                quickRangeSelected[quickRangeRow.investigationParameterId] === item?.optionValue;
              return (
                <Box
                  key={
                    item?.memberPatientReportParameterForRangeValueId ??
                    `${quickRangeRow?.investigationParameterId}-${index}`
                  }
                  className="quick-chip"
                  sx={{
                    padding: "6px 10px !important",
                    cursor: "pointer",
                    ...(isSelected && {
                      "&&": {
                        backgroundColor: "primary.main",
                        color: "#fff",
                        borderColor: "primary.main",
                      },
                    }),
                  }}
                  onClick={() => {
                    if (quickRangeRow) {
                      setQuickRangeSelected((prev) => ({
                        ...prev,
                        [quickRangeRow.investigationParameterId]: item?.optionValue || "",
                      }));
                    }
                    setOpenQuickRangeDialog(false);
                  }}
                >
                  {item?.optionValue}
                </Box>
              );
            })}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ReportParameterSave;
